const ISO_3166_1_SHORT_CODE = /^[a-z]{2}$/i;

type MapboxLocationContextItem = {
  id: string;
  text: string;
  short_code?: string;
};

type MapboxLocationFeature = {
  id: string;
  text: string;
  place_type?: string[];
  geometry?: {coordinates: number[]};
  center?: number[];
  context?: MapboxLocationContextItem[] | null;
};

function contextType(id: string) {
  return (id || '').split('.')[0];
}

function isIso3166CountryCode(shortCode: string | undefined) {
  return typeof shortCode === 'string' && ISO_3166_1_SHORT_CODE.test(shortCode);
}

export default function parseMapboxLocation(feature: MapboxLocationFeature) {
  const {
    id,
    text,
    place_type: placeType = [],
    geometry,
    center,
    context: rawContext,
  } = feature;
  const context = rawContext || [];
  const coordinates = (geometry && geometry.coordinates) || center || [];

  let state;
  let country;

  context.forEach((item) => {
    const type = contextType(item.id);

    if (type === 'region') {
      state = item.text;
    }

    if (type === 'country') {
      country = item.text;
    }
  });

  if (!country) {
    const isoCountryParent = context.find((item) =>
      isIso3166CountryCode(item.short_code)
    );

    if (isoCountryParent) {
      country = isoCountryParent.text;

      if (
        state === country &&
        (placeType.includes('place') || placeType.includes('region'))
      ) {
        state = text;
      }
    } else if (placeType.includes('country')) {
      country = text;
    }
  }

  return {
    apiUid: id,
    city: text,
    state,
    country,
    longitude: coordinates[0],
    latitude: coordinates[1],
  };
}
